export const SET_CGU = 'SET_CGU';
